import React, { useEffect, useState } from "react"
import styled from "styled-components"
import HeaderAnnouncement from "./HeaderAnnouncement"
import NavBar from "./NavBar"
import NavFull from "./NavFull"

const HeaderWrap = styled.header`
	position: fixed;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 100;

	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: ${props => props.theme.colors.tertiary};
	}
`

const Header = (props) => {
	const [navActive, setNavActive] = useState(false)
	const [navTop, setNavTop] = useState("0px")

	useEffect(() => {
		window.addEventListener("resize", setNavTop, true)

		return () => {
      window.removeEventListener('resize', setNavTop);
    };
  }, [])
	
	const toggleNav = (e) => {
		e && e.preventDefault()
		
		calcNavTop()
		
		setNavActive(!navActive)
		
		document.body.classList.toggle('nav-active')
	}

	const calcNavTop = () => {
		let navTop
		const header = document.getElementsByClassName("headerWrap")[0];
		if (header !== undefined) {
			const headerHeight = header.clientHeight
			navTop = `${headerHeight}px`
		}
		
		setNavTop(navTop)
	}

	return (
		<>
			<HeaderWrap className="headerWrap" id="siteHeader">
				<HeaderAnnouncement />
				<NavBar 
					toggleNav={(e) => toggleNav(e)} 
					path={props.path}
					navActive={navActive}
				/>
				<NavFull 
					active={navActive} 
					toggleNav={(e) => toggleNav(e)} 
					navTop={navTop} 
				/>
			</HeaderWrap>
		</>
	)
}

export default Header